import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Link, useNavigate } from "react-router-dom";
import SpinnerFullPage from "../general/spinner/index";
import "./style.css";
import {
  BRANCH_NAME,
  FEATURE_TOGGLE_ASK,
  FEATURE_TOGGLE_CHART_ACCOUNTS,
  FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE,
  FEATURE_TOGGLE_F24,
  FEATURE_TOGGLE_FULFILMENTS,
  FEATURE_TOGGLE_PRE_COG,
  FEATURE_TOGGLE_REPORTS,
  FEATURE_TOGGLE_TAX_CREDIT,
} from "../../config";
import { usePermissions } from "../../customHooks";
import { getListAsk } from "../../store/actions/ask";
import { useIntl } from "react-intl";
import { ALLOWED_COMIC_STUDIO } from "../../constants/constants";
import { Menu } from "antd";
import { getPrecogConfig } from "../../store/actions/precog/config";

const Sidebar = (props) => {
  const {
    activePage,
    // prevPath // anche nei sotto tipi tipo scadenze devo tener traccia della voce attiva di menu
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const main = useSelector((state) => state.main);
  const ask = useSelector((state) => state.ask);
  const currentPermissions = useSelector((state) => state.currentPermissions);
  const usersList = useSelector((state) => state.usersList);
  const user = useSelector((state) => state.user);
  const studio = useSelector((state) => state.studio);
  const company = useSelector((state) => state.company);

  // const [isItemUser, setIsItemUser] = useState(false);
  const [isManagerUser, setIsManagerUser] = useState(false);
  const [loggedUser, setLoggedUser] = useState(user.profile ? (user?.profile?.uuid ? user?.profile?.uuid : user?.profile?.id) : null);
  const [isOwner, setIsOwner] = useState(false);
  const [studioFind, setStudioFind] = useState(null);
  const [permissions, setPermissions] = useState(usePermissions(currentPermissions, isManagerUser, isOwner));
  const [isAskSurveysExists, setIsAskSurveysExists] = useState(main.myType === "STUDIO" ? true : main.myType !== "STUDIO" && ask.surveys.list.length > 0);
  const [isAskToRead, setIsAskToRead] = useState(
    main.myType === "STUDIO" && ask.surveys.toReadAccountant > 0 ? true : main.myType !== "STUDIO" && ask.surveys.toRead > 0
  );

  const { permissionUser, isLoadingSettings } = currentPermissions;
  const MenuRef = useRef();

  const isActiveStatus = useSelector((state) => state?.precog?.precogConfig?.data?.active);

  useEffect(() => {
    if (main.companySelected && main.accountantSelected) dispatch(getPrecogConfig());
  }, [main.companySelected, main.accountantSelected]);

  useEffect(() => {
    if (!MenuRef.current) return undefined;
    let ps = new Scrollbar(MenuRef.current, { wheelPropagation: true });
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [MenuRef?.current]);

  // serve per la sidebar in modalità integrated
  useEffect(() => {
    if ((permissionUser && !permissionUser.status.ended) || isLoadingSettings) return;
    document.body.className = "unfold " + main?.myType?.toLowerCase() + (main.isIntegrated ? " integrated" : "");
  }, [main.myType, permissionUser, isLoadingSettings]);

  useEffect(() => {
    const roles = user?.roles;
    const isOwnerResources = roles?.filter((resource) => resource.actionKey === "OWNER" && (resource.appId === "DBX" || resource.appId === null));
    const currentStudio = isOwnerResources.filter((res) => res.resourceId === main.accountantIdSelected);

    if (currentStudio.length > 0) {
      setIsOwner(true);
    }
  }, [user?.roles]);

  /* useEffect(() => {
    setLoggedUser(user.profile.uuid);
  }, [user.profile]);*/

  /* useEffect(() => {
    const usersListRaw = { ...usersList };
    const itemUsers = usersListRaw.itemUsers;
    if (itemUsers) {
      const checkItemUser = itemUsers.some(
        user => user.id === this.state.loggedUser
      );
      if (checkItemUser) {
        setIsItemUser(true);
      }
    }
  }, [usersList]);*/

  useEffect(() => {
    const usersListRaw = { ...usersList };
    const managerUsers = usersListRaw.managerUsers;
    if (managerUsers) {
      const checkManagerUser = managerUsers.some((user) => user.id === loggedUser);
      if (checkManagerUser) {
        setIsManagerUser(true);
      }
    }
  }, [usersList]);

  useEffect(() => {
    const userRaw = { ...user };
    if (userRaw.roles) {
      const isOwnerResources = userRaw.roles.filter((resource) => resource.actionKey === "OWNER");
      const currentStudio = isOwnerResources?.filter((res) => res.resourceId === main.accountantIdSelected);

      if (currentStudio.length > 0) {
        setIsOwner(true);
      }
    }
  }, [user]);

  useEffect(() => {
    setLoggedUser(user?.profile?.uuid ? user?.profile?.uuid : user?.profile?.id);
  }, [user]);

  useEffect(() => {
    setIsAskToRead(main.myType === "STUDIO" && ask.surveys.toReadAccountant > 0 ? true : main.myType !== "STUDIO" && ask.surveys.toRead > 0);
  }, [ask.surveys]);

  useEffect(() => {
    setIsAskSurveysExists(main.myType === "STUDIO" ? true : main.myType !== "STUDIO" && ask.surveys.list.length > 0);
  }, [ask.surveys]);

  useEffect(() => {
    setPermissions(usePermissions(currentPermissions, isManagerUser, isOwner));
  }, [main, currentPermissions, isManagerUser, isOwner]);

  useEffect(() => {
    if (permissions.isPermissionAsk) {
      if (!ask.surveys.status.started && !ask.surveys.isLoaded && main.accountantUuidSelected && main.companyUuidSelected) {
        dispatch(getListAsk(false));
      }
    }
  }, [main.accountantUuidSelected, main.companyUuidSelected]);

  useEffect(() => {
    if (main?.accountantUuidSelected) {
      setStudioFind(
        studio?.list?.find((x) => x.uuid === main.accountantUuidSelected) ||
          company?.companies?.find((x) => x?.uuid === main?.companyUuidSelected)?.commercialistiList?.find((x) => x?.uuid === main?.accountantUuidSelected)
      );
    }
  }, [main.accountantUuidSelected]);

  const renderIconMenu = (iconName, link, text, badge) => {
    let isActive = activePage === link;
    let elementClass = "singleElement dbx-gainsight-tour-sidebar " + (isActive ? " active" : "");
    return (
      <div className={elementClass + " " + iconName}>
        <Link to={link}>
          {badge === "bullet" && <div className={"singleElementBullet"}>⬤</div>}
          {badge !== "bullet" && typeof badge === "number" && <div className={"singleElementNumericBadge"}>{badge}</div>}
          <FontAwesomeIcon icon={["far", iconName]} style={{ fontSize: "23px" }} />{" "}
        </Link>
        <div className="voicesBar">{renderVoiceMenu(text, link)}</div>
      </div>
    );
  };

  const renderVoiceMenu = (text, link) => {
    let elementClass = "singleElement";
    return (
      <div className={elementClass}>
        <Link to={link} style={{ color: "#FFF" }}>
          <div
            style={{
              margin:
                link === "/documenti" ||
                link === "/scheda-cliente" ||
                link === "/da-firmare" ||
                link === "/digital-sign" ||
                link ===
                  (main.myType === "STUDIO" ? (window.location.href.indexOf("scadenzecliente") > -1 ? "/scadenzecliente" : "/scadenze") : "/scadenzecliente")
                  ? 0
                  : "0",
            }}
          >
            {text}
          </div>
        </Link>
      </div>
    );
  };

  const digitalBoxMenu = () => {
    /** Se per qualche ragione non appaiono i permessi e non li sto ancora caricando allora mostro solo le voci di default*/
    return permissionUser && permissionUser.status.ended ? (
      <div className={"sidebar scuro "}>
        <div className="iconsBar" ref={MenuRef}>
          {renderIconMenu("home", "/", useIntl().formatMessage({ id: "main.sidebar.home" }))}
          {renderIconMenu("cabinet-filing", "/documenti", useIntl().formatMessage({ id: "main.sidebar.documents" }))}
          {((main.myType !== "STUDIO" && permissionUser && permissions.isPermissionDeadlines) || main.myType === "STUDIO") && studioFind?.taxRegion !== "ES"
            ? renderIconMenu(
                "calendar-alt",
                main.myType === "STUDIO"
                  ? window.location.href.indexOf("scadenzecliente") > -1
                    ? {
                        pathname: "/scadenzecliente",
                        state: { viewType: "calendar" }, // or any property you like to add
                      }
                    : "/scadenze"
                  : {
                      pathname: "/scadenzecliente",
                      state: { viewType: "calendar" }, // or any property you like to add
                    },
                useIntl().formatMessage({ id: "main.sidebar.deadlines" })
              )
            : null}

          {FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE === "true" &&
          main.myType === "STUDIO" &&
          permissionUser &&
          permissions.isPermissionClientCard &&
          studioFind?.taxRegion !== "ES"
            ? renderIconMenu("chart-bar", "/scheda-cliente", useIntl().formatMessage({ id: "main.sidebar.customerPage" }))
            : null}
          {main.myType === "STUDIO" && permissionUser && permissions.isPermissionFolderStudio
            ? renderIconMenu("folder-open", "/folders", useIntl().formatMessage({ id: "main.sidebar.folders" }))
            : null}
          {main.myType !== "STUDIO" && permissionUser && permissions.isPermissionFolderItem
            ? renderIconMenu("folder-open", "/folders", useIntl().formatMessage({ id: "main.sidebar.folders" }))
            : null}
          {FEATURE_TOGGLE_ASK === "true"
            ? main.myType === "STUDIO" || (main.myType !== "STUDIO" && permissions.isPermissionAsk && isAskSurveysExists && ask.surveys.isLoaded)
              ? renderIconMenu("envelope", "/ask-list", useIntl().formatMessage({ id: "main.sidebar.ask" }), isAskToRead ? "bullet" : null)
              : null
            : null}
          {main.myType !== "STUDIO" && permissionUser && permissions.isPermissionSignItem
            ? renderIconMenu("pen-alt", "/da-firmare", useIntl().formatMessage({ id: "main.sidebar.toSign" }))
            : null}
          {main.myType === "STUDIO" && studioFind?.taxRegion !== "ES" && permissionUser && permissions.isPermissionSignStudio
            ? renderIconMenu("pen-alt", "/digital-sign", useIntl().formatMessage({ id: "main.sidebar.digitalSignature" }))
            : null}
          {FEATURE_TOGGLE_FULFILMENTS === "true" && main.myType === "STUDIO" && studioFind?.taxRegion !== "ES"
            ? renderIconMenu("tasks", "/fulfilments", useIntl().formatMessage({ id: "main.sidebar.fulfilments" }))
            : null}
          {FEATURE_TOGGLE_PRE_COG === "true" && studioFind?.taxRegion !== "ES" && main.myType === "STUDIO" && (BRANCH_NAME === "dev" || isActiveStatus)
            ? renderIconMenu("envelope-open-text", "/precog", useIntl().formatMessage({ id: "main.sidebar.precog" }))
            : null}

          {FEATURE_TOGGLE_PRE_COG === "true" && studioFind?.taxRegion !== "ES" && main.myType === "STUDIO" && (BRANCH_NAME === "dev" || isActiveStatus)
            ? renderIconMenu("abacus", "/accounting-years-list", useIntl().formatMessage({ id: "main.sidebar.accountingYears" }))
            : null}

          {FEATURE_TOGGLE_CHART_ACCOUNTS === "true" &&
          studioFind?.taxRegion !== "ES" &&
          main.myType === "STUDIO" &&
          (BRANCH_NAME === "dev" || (BRANCH_NAME === "test" && isActiveStatus))
            ? renderIconMenu("book", "/chart-accounts", useIntl().formatMessage({ id: "main.sidebar.accountingPlan" }))
            : null}
          {FEATURE_TOGGLE_REPORTS === "true" || (studioFind?.taxRegion !== "ES" && isActiveStatus)
            ? renderIconMenu("balance-scale", "/reports/home", useIntl().formatMessage({ id: "main.sidebar.reports" }))
            : null}
          {FEATURE_TOGGLE_REPORTS === "true" || (FEATURE_TOGGLE_REPORTS !== "true" && studioFind?.taxRegion !== "ES" && isActiveStatus)
            ? BRANCH_NAME === "dev" && renderIconMenu("balance-scale", "/reports/onefront", useIntl().formatMessage({ id: "main.sidebar.reportsOnefront" }))
            : null}
          {FEATURE_TOGGLE_TAX_CREDIT === "true" && studioFind?.taxRegion !== "ES"
            ? renderIconMenu("euro-sign", "/tax-credit", useIntl().formatMessage({ id: "main.sidebar.taxCredit" }))
            : null}
          {FEATURE_TOGGLE_F24 === "true" && studioFind?.taxRegion !== "ES" ? renderIconMenu("fa-envelope-open-dollar", "/f24", "F24") : null}
          {FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE === "true" &&
          main.myType === "STUDIO" &&
          permissionUser &&
          permissions.isPermissionClientCard &&
          studioFind?.taxRegion === "ES"
            ? renderIconMenu(
                "chart-bar",
                "/statistiche",
                useIntl().formatMessage({ id: "main.sidebar.businessPerformance", defaultMessage: "Business Performance" })
              )
            : null}
        </div>
        <div />
      </div>
    ) : /**
     * È corretto che ci sia lo spinner a tutto schermo perchè altrimenti avrei
     * le voci di menu che appaiono e scompaiono in caso di non permesso
     * */
    isLoadingSettings ? (
      <SpinnerFullPage myClass="fullPage" size="large" />
    ) : (
      <div className={"sidebar scuro "}>
        <div className="iconsBar">
          {renderIconMenu("home", "/", "Home")}
          {renderIconMenu("cabinet-filing", "/documenti", "Documenti")}
          {renderIconMenu(
            "calendar-alt",
            main.myType === "STUDIO"
              ? window.location.href.indexOf("scadenzecliente") > -1
                ? {
                    pathname: "/scadenzecliente",
                    state: { viewType: "calendar" }, // or any property you like to add
                  }
                : "/scadenze"
              : {
                  pathname: "/scadenzecliente",
                  state: { viewType: "calendar" }, // or any property you like to add
                },
            "Scadenze"
          )}
        </div>
        <div />
      </div>
    );
  };

  const comicMenu = () => {
    function getItem(label, key, icon, children) {
      return {
        key,
        icon,
        children,
        label,
      };
    }

    const goTo = (key) => {
      const urls = {
        home: "/",
        documents: "/documenti",
        folders: "/folders",
        ask: "/richieste",
        precog: "/precog",
        ask: "/ask-list",
        scheda_cliente: studioFind?.taxRegion !== "ES" ? "/scheda-cliente" : "/statistiche",
        statistiche: "/statistiche",
        report: "/reports/home",
        reportOnefront: "/reports/onefront",
        toSign: "/da-firmare",
        digitalSignature: "/digital-sign",
        accountingYears: "/accounting-years-list",
        customer_management: "/customer-management",
        deadlines: main.myType === "STUDIO" ? (window.location.href.indexOf("scadenzecliente") > -1 ? "/scadenzecliente" : "/scadenze") : "/scadenzecliente",
      };
      const menuType = localStorage.getItem("menuToggle");
      if (menuType === "fold") {
        localStorage.setItem("menuToggle", "unfold");
        dispatch({ type: "SET_MENU_TOGGLE", payload: "unfold" });
      }
      return navigate(urls[key] || "/");
    };

    const items = [
      getItem(useIntl().formatMessage({ id: "main.sidebar.home" }), "home", <FontAwesomeIcon icon={["far", "home"]} />),
      getItem(useIntl().formatMessage({ id: "main.sidebar.accounting" }), "accounting", <FontAwesomeIcon icon={["far", "list"]} />, [
        getItem(useIntl().formatMessage({ id: "main.sidebar.precog" }), "precog", null),
        getItem(useIntl().formatMessage({ id: "main.sidebar.reports" }), "report", null),
        getItem(useIntl().formatMessage({ id: "main.sidebar.accountingYears" }), "accountingYears", null),
      ]),
      (main.myType !== "STUDIO" && studioFind?.taxRegion !== "ES" && permissionUser && permissions.isPermissionDeadlines) ||
        (main.myType === "STUDIO" &&
          getItem(useIntl().formatMessage({ id: "main.sidebar.deadlines" }), "deadlines", <FontAwesomeIcon icon={["far", "calendar-alt"]} />)),
      getItem(useIntl().formatMessage({ id: "main.sidebar.collaboration" }), "documents", <FontAwesomeIcon icon={["far", "cabinet-filing"]} />, [
        getItem(useIntl().formatMessage({ id: "main.sidebar.documental" }), "documents", null),
        getItem(useIntl().formatMessage({ id: "main.sidebar.folders" }), "folders", null),
        getItem(useIntl().formatMessage({ id: "main.sidebar.ask" }), "ask", null),
        main.myType !== "STUDIO" &&
          studioFind?.taxRegion !== "ES" &&
          permissionUser &&
          permissions.isPermissionSignItem &&
          getItem(useIntl().formatMessage({ id: "main.sidebar.toSign" }), "toSign"),
        main.myType === "STUDIO" &&
          studioFind?.taxRegion !== "ES" &&
          permissionUser &&
          permissions.isPermissionSignStudio &&
          getItem(useIntl().formatMessage({ id: "main.sidebar.digitalSignature" }), "digitalSignature"),
      ]),
      getItem(useIntl().formatMessage({ id: "main.sidebar.customers" }), "customer_management", <FontAwesomeIcon icon={["far", "id-card"]} />),
      FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE === "true" && main.myType === "STUDIO" && permissionUser && permissions.isPermissionClientCard
        ? studioFind?.taxRegion !== "ES"
          ? getItem(useIntl().formatMessage({ id: "main.sidebar.customerPage" }), "scheda_cliente", <FontAwesomeIcon icon={["far", "chart-bar"]} />)
          : getItem(
              useIntl().formatMessage({ id: "main.sidebar.businessPerformance", defaultMessage: "Business Performance" }),
              "statistiche",
              <FontAwesomeIcon icon={["far", "chart-bar"]} />
            )
        : null,
    ];

    return (
      <div className={"sidebar scuro "}>
        <div className="iconsBar" ref={MenuRef}>
          <Menu
            rootClassName={"comic-sidebar"}
            mode={"vertical"}
            theme={main.myType === "STUDIO" ? "light" : "dark"}
            inlineCollapsed={main.menuToggle === "unfold"}
            onClick={(val) => goTo(val.key)}
            items={items}
          />
        </div>
      </div>
    );
  };

  return main.myType === "STUDIO" && ALLOWED_COMIC_STUDIO[main.accountantSelected]?.indexOf(user.profile.id) > -1 ? comicMenu() : digitalBoxMenu();
};

export default Sidebar;
